// @ts-nocheck
import React, { useEffect, useState } from 'react';
import '../styles/Login.css';
import { Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { clearToken, getToken, storeToken } from '../helpers/StorageHelper';
import { useTranslation } from 'react-i18next';
import { ApplicationContext } from '../contexts/ApplicationContext';
import packageJson from '../../package.json';
import { getHubURL } from '@src/helpers/URLHelper';
import { AppConfig } from '@src/contexts/AppConfig';
import SudofyBranding from '@src/components/Branding';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import OTPAuth from './OTPAuth/OTPAuth';

//Images
import { styled } from 'styled-components';
import TimeRemaining from './Timer/TimeRemaining';
import { AxiosError, AxiosResponse } from 'axios';
import CurrentUserResponse from '@src/api/responses/CurrentUserResponse';
import { setCurrentUser } from '@src/store/reducers/currentUserReducer';
import { setotpAuth } from '@src/store/reducers/otpAuthReducer';
import { RESTAURANT } from '@src/Constants';
import { isValidPath } from '@src/helpers/Helpers';
import { LocalStorage } from '@src/storage/LocalStorage';
import { setDefaultRestaurant, setRestaurants } from '@src/store/reducers/branchReducer';
import OnboardingScreens from '@src/pages/OnboardingScreens/OnboardingScreens';
import { IsMobileWidth } from './MediaQueryUtils';
import { setIsOnBoardingState } from '@src/store/reducers/UIReducer';

const LoginContainer = styled.div`
	width: 100vw;
	padding: 20px;
	height: 100vh;
	@media screen and (max-width: 600px) {
		padding: 0;
	}
`;
const StyledPaperContainer = styled(Paper)`
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
	flex-direction: column;
	width: 337px;
	height: 85vh;
	background: transparent;
`;

const StyledBannerGrid = styled(Grid)`
	img {
		max-width: 580px;
		height: 95vh;
		object-fit: contain;
		// @media screen and (max-width: 1300px) {
		// 	width: 450px;
		// 	height: 95vh;
		// }
	}
	@media screen and (max-width: 1200px) {
		display: none;
	}
`;

const Login = () => {
	const { apiService } = React.useContext(ApplicationContext);

	const localStorage = new LocalStorage();
	const isOnBoardingDone = localStorage.getItem('onBoarding');

	const otpAuth = useAppSelector((state) => state?.otpAuth?.value);
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const isRestaurant = currentUser?.type?.toLowerCase() === RESTAURANT;
	const isOnboardingState: any = useAppSelector((state) => state?.UI?.isOnboardingState);
	const { errorCase } = useParams();
	const { t } = useTranslation();
	const dispatch = useAppDispatch();

	const config = React.useContext(AppConfig);

	const errorMessages = {
		incorrectRole: 'Only admins and users can access our web app.',
		notLoggedIn: 'You are not logged in.',
		invalidToken: 'Invalid token.',
		expireToken: 'Your session has expired. Please log in again.',
		userDelete: 'Your account has been deleted',
		userNotFound: 'This account has been deleted',
	};

	const [isLoggingIn, setLoggingIn] = useState(false);
	const [isValidatingToken, setValidatingToken] = useState(false);
	const [loginError, setLoginError] = useState('');
	const isMobilWidth = IsMobileWidth();

	const countryCode = '+91';
	const [phoneNumber, setPhoneNumber] = useState<string>('');
	const [otp, setOtp] = useState<string[]>(['', '', '', '']);
	const [step, setStep] = useState<string>('');
	const [error, setError] = useState<string>('');
	const [otpExpiryTime, setOtpExpiryTime] = useState<number>(-1);
	const [loading, setLoading] = useState(false);
	const [disable, setDisable] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();

	const isOrganizationSelected = () => {
		// if (organization) {
		// 	return '/chats';
		// }
		if (isRestaurant) {
			return '/restaurants';
		}
		return '/suppliers';
	};

	const logoutToClearSession = () => {
		apiService.logoutCallV2();
	};

	const getBranch = (path, type) => {
		try {
			if (type === RESTAURANT) {
				apiService.getRestaurants(
					(response: AxiosResponse) => {
						const data = response?.data?.data;
						const branch = data?.find((item: any) => item?.id === Number(path?.branchId));

						if (branch) {
							dispatch(setRestaurants(data));
							dispatch(setDefaultRestaurant(branch));
							const localStorage = new LocalStorage();
							localStorage.removeItem('prevPath');
							navigate(path?.path);
						} else {
							navigate('/restaurants');
						}
					},
					(error: AxiosError) => {}
				);
			} else {
				apiService.getAllSuppliers(
					(response: AxiosResponse) => {
						const data = response?.data?.data;
						const branch = data?.find((item: any) => item?.id === Number(path?.branchId));

						if (branch) {
							dispatch(setRestaurants(data));
							dispatch(setDefaultRestaurant(branch));
							const localStorage = new LocalStorage();
							localStorage.removeItem('prevPath');
							navigate(path?.path);
						} else {
							navigate('/suppliers');
						}
					},
					(error: AxiosError) => {}
				);
			}
		} catch (err) {
			if (type === RESTAURANT) {
				navigate('/restaurants');
			} else {
				navigate('/suppliers');
			}
		} finally {
			setError('');
			setLoginError('');
			setLoading(false);
		}
	};

	const handleOTPSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setLoading(true);
		const formattedNumber = countryCode + phoneNumber;
		const data = {
			phone: formattedNumber,
			otp: otp?.join(''),
		};
		apiService.loginCall(
			data,
			(response: AxiosResponse) => {
				const currentUserResponse = new CurrentUserResponse(response.data.data.user);
				dispatch(setCurrentUser(currentUserResponse.currentUser));
				dispatch(
					setotpAuth({
						phoneNumber: '',
						expiryTime: '',
					})
				);

				// Store token in local storage
				storeToken(response?.data?.data?.token);

				// Android web interface
				// if (window.AndroidWebInterface) {
				// 	window.AndroidWebInterface.registerUserToken(response.data.data.token ?? '');
				// }
				// if (response?.data?.data?.onBoarding && isMobilWidth) {
				// 	setIsOnboardingVisible(true);
				// 	return;
				// }

				//Navigate to route from where you logout or hit the url
				const localStorage = new LocalStorage();
				const storedPrevPathJSON = localStorage.getItem('prevPath');
				const path = JSON.parse(storedPrevPathJSON);
				if (path?.path) {
					if (isValidPath(currentUserResponse?.currentUser?.type?.toLowerCase(), path?.path)) {
						getBranch(path, currentUserResponse?.currentUser?.type?.toLowerCase());
						return;
					}
				}

				localStorage.removeItem('prevPath');
				setError('');
				setLoginError('');
				setLoading(false);
				if (currentUserResponse?.currentUser?.type?.toLowerCase() === RESTAURANT) {
					navigate('/restaurants');
				} else {
					// navigate(`/dashboard`);
					// navigate(`/chats`);
					navigate('/suppliers');
				}
			},
			(error: AxiosError) => {
				setLoading(false);
				setError('Please enter a valid code');
				setLoginError('');
			}
		);
	};

	const validateNumber = (number) => {
		return number?.length === 10;
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setLoading(true);
		const formattedNumber = countryCode + phoneNumber;
		if (validateNumber(phoneNumber)) {
			apiService.generateOTP(
				formattedNumber,
				(response: AxiosResponse) => {
					const otpExpiry = new Date().getTime() + 2 * 60 * 1000;
					const data = {
						phoneNumber: formattedNumber.slice(3),
						expiryTime: otpExpiry,
					};
					setOtpExpiryTime(otpExpiry);
					setLoading(false);
					setStep('2');
					setError('');
					setLoginError('');
					dispatch(setotpAuth(data));

					const queryParams = new URLSearchParams(location.search);
					queryParams.set('step', '2');

					const newUrl = `${location.pathname}?${queryParams.toString()}`;
					window.history.replaceState(null, '', newUrl);
				},
				(error: AxiosError) => {
					setError('Please enter a valid number');
					setLoginError('');
					setLoading(false);
				}
			);
		} else {
			if (phoneNumber?.length < 10 || phoneNumber?.length > 10) {
				setError('Phone number should contain 10 digits');
				setLoginError('');
				setLoading(false);
			}
		}
	};

	const updateStepper = (stepNumber: string) => {
		if (stepNumber === '1') {
			window.history.replaceState(null, '', location.pathname);
		}
		setStep(stepNumber);
		setError('');
		setLoginError('');
		setOtp(['', '', '', '']);
	};

	useEffect(() => {
		const token = getToken();

		//In PWA app show onboarding when user is not logged in
		if (
			isMobilWidth &&
			(!token || errorCase) &&
			!isOnBoardingDone &&
			isOnboardingState === 'invisible'
		) {
			dispatch(setIsOnBoardingState('visible'));
			setLoggingIn(true);
			return;
		}

		if (errorCase) {
			setLoginError(errorMessages[errorCase]);
			setLoggingIn(true);
			return;
		}

		if (token) {
			try {
				setValidatingToken(true);
				//As a ME Call
				apiService.retrieveCurrentUserCallV2(
					(response) => {
						navigate(isOrganizationSelected());
						setValidatingToken(false);
						return;
					},
					(error) => {
						console.log(error);
						setLoggingIn(true);
					},
					navigate,
					currentUser?.userId
				);
			} catch (error) {
				console.error('Error retrieving current user', error);
				setLoggingIn(true);
			} finally {
				setValidatingToken(false);
			}
		} else {
			setLoggingIn(true);
		}
	}, []);

	//To maintain step 2 state on refresh
	useEffect(() => {
		if (step === '1') {
			window.history.replaceState(null, '', location.pathname);
			return;
		}
		const queryParams = new URLSearchParams(location.search);
		const queryStep = queryParams.get('step');
		if (queryStep) {
			setStep(queryStep);
			setOtpExpiryTime(otpAuth?.expiryTime);
			setPhoneNumber(otpAuth?.phoneNumber);
			return;
		}
		if (!step) {
			setStep('1');
			return;
		}
	}, [location.search, step]);

	// if (isMobilWidth && isOnboardingState === 'visible' && !isOnBoardingDone) {
	// 	return <OnboardingScreens />;
	// } 
	
	// else if (isMobilWidth) {
	// 	return (
	// 		<div style={{ background: '#FFBE00', paddingTop: '20px' }}>
	// 			<LoginContainer
	// 				style={{
	// 					background: '#FDFDFD',
	// 					borderTopRightRadius: '20px',
	// 					borderTopLeftRadius: '20px',
	// 				}}
	// 				className="login-container"
	// 			>
	// 				{isLoggingIn ? (
	// 					<Grid container spacing={0} justifyContent="center" alignItems="center">
	// 						{/* Login Form*/}
	// 						<Grid container item xs={12} sm={7} justifyContent="right">
	// 							<StyledPaperContainer elevation={0} style={{ background: 'transparent' }}>
	// 								<OTPAuth
	// 									step={step}
	// 									updateStepper={updateStepper}
	// 									loginError={loginError}
	// 									error={error}
	// 									setError={setError}
	// 									countryCode={countryCode}
	// 									phoneNumber={phoneNumber}
	// 									setPhoneNumber={setPhoneNumber}
	// 									otp={otp}
	// 									setOtp={setOtp}
	// 									loading={loading}
	// 									handleSubmit={handleSubmit}
	// 									handleOTPSubmit={handleOTPSubmit}
	// 								/>
	// 								{step === '2' ? (
	// 									<div
	// 										style={{
	// 											display: 'flex',
	// 											justifyContent: 'center',
	// 											width: '340px',
	// 											padding: '20px',
	// 										}}
	// 									>
	// 										<Typography
	// 											variant="body1"
	// 											style={{ display: 'flex', gap: '5px' }}
	// 											className="default-lighter-text"
	// 										>
	// 											<TimeRemaining expiryTime={otpExpiryTime} handleResend={handleSubmit} />
	// 										</Typography>
	// 									</div>
	// 								) : null}
	// 							</StyledPaperContainer>
	// 						</Grid>

	// 						{/*Login Banner Image */}
	// 						<StyledBannerGrid item xs={12} sm={5}>
	// 							<Grid container justifyContent="right">
	// 								<Grid item>
	// 									<img src={'/login-banner-1.jpg'} alt="login-banner" loading="lazy" />
	// 								</Grid>
	// 							</Grid>
	// 						</StyledBannerGrid>
	// 					</Grid>
	// 				) : (
	// 					<Box
	// 						sx={{
	// 							width: '100%',
	// 							height: '100%',
	// 							display: 'flex',
	// 							alignItems: 'center',
	// 							justifyContent: 'center',
	// 						}}
	// 					>
	// 						<div className="chat__body__loadingMore__wrapper">
	// 							<CircularProgress size={28} />
	// 						</div>
	// 					</Box>
	// 				)}
	// 			</LoginContainer>
	// 		</div>
	// 	);
	// }

	return (
		<LoginContainer className="login-container">
			{isLoggingIn ? (
				<Grid container spacing={0} justifyContent="center" alignItems="center">
					{/* Login Form*/}
					<Grid container item xs={12} sm={7} justifyContent="right">
						<StyledPaperContainer elevation={0} style={{ background: 'transparent' }}>
							<OTPAuth
								step={step}
								updateStepper={updateStepper}
								loginError={loginError}
								error={error}
								setError={setError}
								countryCode={countryCode}
								phoneNumber={phoneNumber}
								setPhoneNumber={setPhoneNumber}
								otp={otp}
								setOtp={setOtp}
								loading={loading}
								handleSubmit={handleSubmit}
								handleOTPSubmit={handleOTPSubmit}
							/>
							{step === '2' ? (
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										width: '340px',
										padding: '20px',
									}}
								>
									<Typography
										variant="body1"
										style={{ display: 'flex', gap: '5px' }}
										className="default-lighter-text"
									>
										<TimeRemaining expiryTime={otpExpiryTime} handleResend={handleSubmit} />
									</Typography>
								</div>
							) : null}
						</StyledPaperContainer>
					</Grid>

					{/*Login Banner Image */}
					<StyledBannerGrid item xs={12} sm={5}>
						<Grid container justifyContent="right">
							<Grid item>
								<img style={{borderRadius: "16px", height: "100%", }} src={'/login-banner.jpg'} alt="login-banner" loading="lazy"  />
							</Grid>
						</Grid>
					</StyledBannerGrid>
				</Grid>
			) : (
				<Box
					sx={{
						width: '100%',
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div className="chat__body__loadingMore__wrapper">
						<CircularProgress size={28} />
					</div>
				</Box>
			)}
		</LoginContainer>
	);
};

export default Login;
